import { Button, IconButton, Toolbar, Typography } from "@material-ui/core";
import { Edit, Delete } from "@material-ui/icons";
import React from "react";
import { deleteMacro, listMacros } from "../../sdk/macros";
import { Macro } from "../../../../../services/macros/types/macros";
import { DataGrid } from "@material-ui/data-grid";
import { ManageMacroDialog } from "./components/manage-macro";
import ConfirmDialog from "./components/confirm-dialog";

export const MacrosList: React.FC = () => {
  const [macros, setMacros] = React.useState<Macro[]>([]);
  const [size, setSize] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [isManageDialogOpen, setManageDialogOpen] = React.useState(false);
  const [editProps, setEditProps] = React.useState(undefined);
  const [confirmOpen, setConfirmOpen] = React.useState(false);
  const [itemToDelete, setSetItemToDelete] = React.useState<string | undefined>(
    undefined
  );

  const getMacros = () => {
    listMacros()
      .then((data) => {
        setLoading(true);
        setMacros(
          data.macros.sort((a, b) => a.shortKey.localeCompare(b.shortKey))
        );
        setSize(data.macros.length || 0);
      })
      .finally(() => setLoading(false));
  };

  const confirmDelete = () => {
    if (itemToDelete) {
      deleteMacro(itemToDelete)
        .then(() => {
          setLoading(true);
          setConfirmOpen(false);
          setSetItemToDelete(undefined);
          getMacros();
        })
        .finally(() => setLoading(false));
    }
  };

  const handleEdit = (macro: any) => {
    setEditProps(macro);
    setManageDialogOpen(true);
  };

  const handleDelete = (id: string) => {
    setSetItemToDelete(id);
    setConfirmOpen(true);
  };

  const handleCancelDelete = () => {
    setConfirmOpen(false);
    setSetItemToDelete(undefined);
  };

  React.useEffect(() => {
    getMacros();
  }, []);

  return (
    <section>
      <Toolbar variant="dense" style={{ marginTop: "20px" }}>
        <Typography variant="h4" style={{ flexGrow: 1 }}>
          Macros
        </Typography>
        <Button
          style={{ marginLeft: "10px" }}
          variant="contained"
          onClick={() => setManageDialogOpen(true)}
          color="primary"
        >
          Create
        </Button>
        {isManageDialogOpen ? (
          <ManageMacroDialog
            onSave={getMacros}
            macro={editProps}
            show={isManageDialogOpen}
            onClose={() => setManageDialogOpen(false)}
          />
        ) : null}
      </Toolbar>
      <ConfirmDialog
        open={confirmOpen}
        onClose={handleCancelDelete}
        onConfirm={confirmDelete}
      />
      <div style={{ display: "flex", height: "750px", marginTop: "20px" }}>
        <DataGrid
          rows={macros}
          pagination
          rowCount={size}
          columns={[
            { field: "title", headerName: "Title", width: 300 },
            { field: "shortKey", headerName: "Shortcut", width: 300 },
            { field: "message", headerName: "Message", width: 300 },
            {
              field: "edit",
              headerName: "Edit",
              width: 150,
              renderCell: (params) => (
                <IconButton onClick={() => handleEdit(params.row)}>
                  <Edit />
                </IconButton>
              ),
            },
            {
              field: "delete",
              headerName: "Delete",
              width: 150,
              renderCell: (params) => {
                const macro = params.row as Macro;
                return (
                  <IconButton onClick={() => handleDelete(macro.id)}>
                    <Delete />
                  </IconButton>
                );
              },
            },
          ]}
          paginationMode="client"
          loading={loading}
          pageSize={10}
        />
      </div>
    </section>
  );
};
